(function ($) {
    var onAirPlayer = function() {
        var cls = this;
        {
            cls.type = 'application/x-mpegurl';
            cls.playerController = $('#player-control');
            cls.playerTarget = $('#videojs-player');
            cls.broadTypCd = $("#broadTypCd").val();
            cls.liveStreamUrl = '//gstv-gsshop.gsshop.com/gsshop_hd/_definst_/gsshop_hd.stream/playlist.m3u8';
            cls.dataStreamUrl = '//gstv-myshop.gsshop.com/myshop_hd/_definst_/myshop_hd.stream/playlist.m3u8';
            cls.videoSrc = "LIVE" == cls.broadTypCd ? cls.liveStreamUrl : cls.dataStreamUrl;
            cls.pauseTime;
            cls.playerOption = {
                preload: 'auto',
                autoplay: true,
                muted: true,
                playsinline: true,
                fullscreenToggle: false,
                sources: [{'type':cls.type,'src':cls.videoSrc}]
            }
        }

        // 방송 타입에 따른 스트리밍 URL 재설정
        cls.resetStreamUrl = function(broadType) {
            cls.broadTypCd = broadType;
            cls.playerController.removeAttr('class').addClass('play');
            cls.playerController.find('.volume').addClass('off');
            cls.player.muted(true);
            cls.player.src("LIVE" == cls.broadTypCd ? cls.liveStreamUrl : cls.dataStreamUrl);
        };

        cls.player = videojs('videojs-player', cls.playerOption);

        cls.player.on('play', function(){
            cls.playerTarget = $('#videojs-player');
            if (GsBase.os =='android') {
                $('.video-js').append( cls.playerController );
            }
            setTimeout(function(){
                if ( cls.playerTarget.hasClass('vjs-playing') ) {
                    cls.playerController.removeClass('ready');
                }
            }, 1000);
        });

        cls.player.on('fullscreenchange', function(){
            if (this.isFullscreen()) {
                if (!cls.playerTarget.hasClass('vjs-playing')) cls.playerController.find('.play').click();
            } else {
                cls.playerController.find('.stop').click();
            }
        });

        cls.playerController.find('.play').on('click', function(){
            cls.playerController.removeAttr('class').addClass('play');
            cls.player.play();
        });

        cls.playerController.find('.stop').on('click', function(){
            cls.playerController.addClass('on').addClass('pause');
            cls.player.pause();
        });

        cls.playerController.find('.volume').on('click', function(){
            if ($(this).hasClass('off')) {
                $(this).removeClass('off');
                cls.player.muted(false);
            } else {
                $(this).addClass('off');
                cls.player.muted(true);
            }
        });

        cls.playerController.find('.fullscreen').on('click', function(){
            $('.vjs-fullscreen-control').click();
            if ( GsBase.mobileBrowser ) $('.vjs-play-control').click();
        });

        cls.playerController.find('button').on('click', function(e){
            e.stopPropagation();
            clearTimeout( cls.pauseTime );
            cls.pauseTime = null;
        });

        cls.playerController.find('.go').on('click', function(){
            var linkUrl = $('#currentBroadLink').attr('href');
            document.location.href= linkUrl;
        });

        if ( GsBase.mobileBrowser ) {
            $('#player-control-inner').on('click', function(e) {
                e.stopPropagation();

                clearTimeout( cls.pauseTime );
                cls.pauseTime = null;

                if ( cls.playerController.hasClass('on')) {
                    if ( cls.playerTarget.hasClass('vjs-playing')) {
                        cls.playerController.removeClass('on');
                    }
                } else {
                    cls.playerController.addClass('on');

                    if ( cls.playerTarget.hasClass('vjs-playing')) {
                        cls.pauseTime = setTimeout(function(){
                            cls.playerController.removeClass('on').removeClass('over');
                        },3000);
                    }
                }

                if ( cls.playerTarget.hasClass('vjs-paused')) {
                    cls.playerController.removeClass('play').addClass('pause');
                }else {
                    cls.playerController.addClass('over');
                }
            });
        }
        return cls;
    };
    window.onAirPlayer = window.onAirPlayer || new onAirPlayer();

})(jQuery);